import COLORS from '../../colors';
import Button from './Button';

interface SectionButtonsProps {
  leftButtonLabel: string;
  rightButtonLabel: string;
  onToggleAll: (status: boolean) => void;
  rightBackgroundColor?: string;
  rightTextColor?: string;
  rightHoverColor?: string;
}

const SectionButtons = ({
  onToggleAll,
  leftButtonLabel,
  rightButtonLabel,
  rightBackgroundColor,
  rightTextColor,
  rightHoverColor
}: SectionButtonsProps) => {
  return (
    <div>
      <Button
        label={leftButtonLabel}
        backgroundColor={COLORS.NEUTRAL_925}
        hoverBackgroundColor={COLORS.BUTTON_SECONDARY_HOVER}
        textColor={COLORS.PRIMARY_500}
        showShadow={false}
        onClick={() => onToggleAll(false)}
      />
      <Button
        label={rightButtonLabel}
        backgroundColor={rightBackgroundColor || COLORS.NEUTRAL_900}
        hoverBackgroundColor={rightHoverColor || COLORS.BUTTON_SECONDARY_HOVER}
        textColor={rightTextColor || COLORS.PRIMARY_500}
        onClick={() => onToggleAll(true)}
      />
    </div>
  );
};

export default SectionButtons;
